import React from 'react';
import styles from './Announcements.module.scss';
import { SearchTerm } from '@views/Search/Tips';

export default function SearchSuggestions({ terms }: { terms: string[] }) {
  return (
    <div className={styles.searchTerms}>
      {terms?.map((term) => (
        <SearchTerm key={term} term={term} className={styles.example} />
      ))}
    </div>
  );
}
